module.exports = __webpack_public_path__ + "assets/82dab576514a4e2659d00f918b018756.svg";